import { currentPage, initNewSection } from '../common/layout';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });
}
currentPage.pageLoadMore = ($html, $btnBox) => {
    //$btnBox.replaceWith($html);
    // bannerLazyload();

    let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
    loadMoreButton?.addEventListener('click', (event) => {
      event.preventDefault();
      getLoadMoreContent().then((api) => {
        api.loadMoreButtonNew(loadMoreButton);
      });
    });

    initNewSection($html)
}